module.exports = __webpack_public_path__ + "static/media/xml.f3de2bd9.svg";